import React, { Component } from 'react'
import { Link } from 'react-router';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { FieldCol, FieldGroup, FieldLabel, FieldTextarea, FieldSelect, FieldInput, FieldDate } from '../../Elements';
import { displayDateFormat, backendDateFormat, days, securityGroups, imgStoragePath } from '../../../../constants';
import { titanInstance ,gaTelesisInstance, avationPlcInstance, mtInstance, leshaBankInstance, hanwahaInstance} from '../../../../shared_elements/components';
import { globalGetService } from '../../../../globalServices';
import { checkApiStatus } from '../../../../utils_v2';
import { leaseStatus } from '../../../../shared/components';
import { jetStreamInstance } from '../../../../lease_management/Leases';
export default class LeaseRentalEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rentalInvoiceView: {lease_rental_period:1},
            adminFlag: false,
            contracterFlag: false,
            bankList:[],
            error:{}
        }
    }
    componentDidMount() {
        let data = JSON.parse(JSON.stringify(this.props.rentalInvoiceView));
        delete data['lease_type'];
        delete data['lease_type_accounting'];
        // this.setState({
        //     rentalInvoiceView: data
        // });
        if (data?.management_bank_id && data?.management_bank_id.name && data?.management_bank_id.lessor) {
            data.management_bank_id = {
                ...data?.management_bank_id,
                name: `${data?.management_bank_id?.lessor.name} - ${data?.management_bank_id?.name}`
            }
        }
        this.setState(prevState => ({
            rentalInvoiceView: {
                ...prevState.rentalInvoiceView,
                ...data,
                lease_rental_period: data?.lease_rental_period || 1
            }
        }));
        this.getBankList()
    }
    updateForm = (type, value) => {
        if (type == 'remarks_date'|| type === 'rental_qis_number' || type === 'rental_sales_order_number'){
            this.setState(prevState => ({
            ...prevState,
            rentalInvoiceView: {
                ...prevState.rentalInvoiceView,
                rental_account_titan_extra_fields: {
                    ...prevState.rentalInvoiceView.rental_account_titan_extra_fields,
                [type]: value
                }
            }
        }))
        } else if (type === 'rental_invoice_is_due_day_last_day_month' && jetStreamInstance) {
            this.setState(prevState => ({
                ...prevState,
                rentalInvoiceView: {
                    ...prevState.rentalInvoiceView,
                    rental_invoice_is_due_day_last_day_month: value,
                    rental_invoice_due_day_of_month: null 
                }
            }));
        } else {
            this.setState(prevState => ({
                ...prevState,
                rentalInvoiceView: {
                    ...prevState.rentalInvoiceView,
                    [type]: value
                }
            }))
        }
        if (this.state.error[type]) {
            this.setState(prevState => ({ ...prevState, error: { ...prevState.error, [type]: '' } }));
        }
    }

    getBankList() {
        globalGetService(`console/bank-details/`, this.props.activeTab==='1' ? { dropdown: true , contract_id:this.props.rentalInvoiceView?.id} : { dropdown: true})
            .then(response => {
                if (checkApiStatus(response)) {
                const Banks = response.data.data.map(bank => ({ ...bank, name:  `${bank.lessor.name} - ${bank.name}` }));
                this.setState({ bankList: Banks });
            }
            })
    }
    
    updateRentalInvoice = (e) => {
        e.preventDefault();
        const {rentalInvoiceView}= this.state
        let data = Object.assign({}, this.state.rentalInvoiceView);
        let payload = {
            rental_invoice_day_of_month: rentalInvoiceView.rental_invoice_day_of_month ? rentalInvoiceView.rental_invoice_day_of_month :null,
            rental_invoice_due_day_of_month: rentalInvoiceView.rental_invoice_due_day_of_month? rentalInvoiceView.rental_invoice_due_day_of_month: null,
            rental_invoice_is_due_day_next_month: rentalInvoiceView.rental_invoice_is_due_day_next_month,
            rental_description: rentalInvoiceView.rental_description,
            rental_default_bank:rentalInvoiceView?.rental_default_bank ||null,
            lease_rental_period:rentalInvoiceView.lease_rental_period,
            lease_based_invoice_start_day:rentalInvoiceView.lease_rental_period===1?null:rentalInvoiceView.lease_based_invoice_start_day,
        }

        if(titanInstance || avationPlcInstance || mtInstance || leshaBankInstance){
            payload = {...payload, remarks : rentalInvoiceView.remarks_rental, reference_number:rentalInvoiceView.reference_number_rental,
                rental_account_titan_extra_fields:{remarks_date: rentalInvoiceView?.rental_account_titan_extra_fields?.remarks_date ? moment(rentalInvoiceView?.rental_account_titan_extra_fields?.remarks_date).format(backendDateFormat) : null}
            }
        } else if (gaTelesisInstance) {
            payload = {
                ...payload,
                reference_number: rentalInvoiceView.reference_number_rental,
                management_bank_id: rentalInvoiceView?.management_bank_id?.id ? rentalInvoiceView?.management_bank_id?.id : rentalInvoiceView?.management_bank_id||null,
                management_tax: rentalInvoiceView.management_tax || null,
                vat_tax: rentalInvoiceView.vat_tax || 0,
                rental_account_titan_extra_fields: {
                    rental_qis_number: rentalInvoiceView?.rental_account_titan_extra_fields?.rental_qis_number || null,
                    rental_sales_order_number : rentalInvoiceView?.rental_account_titan_extra_fields?.rental_sales_order_number || null
                }
            }
        } else if (hanwahaInstance) {
            payload = {
                ...payload,
                rental_account_code: rentalInvoiceView?.rental_account_code || null,
        } 
        } else if (jetStreamInstance) {
            payload = {
                ...payload,
                rental_invoice_is_due_day_last_day_month: rentalInvoiceView?.rental_invoice_is_due_day_last_day_month
            }
        }
        let validateNewInput = {};
        let hasError = false;
        if (rentalInvoiceView.lease_rental_period === 2 && !rentalInvoiceView.lease_based_invoice_start_day) {
            validateNewInput.lease_based_invoice_start_day = 'Please select Invoice Day';
            hasError = true;
        }
        if (this.props.activeTab === '2') {
            if (!rentalInvoiceView.management_tax) {
                validateNewInput.management_tax = 'Please enter Management Fee %';
                hasError = true;
            }
            // if (!rentalInvoiceView.vat_tax) {
            //     validateNewInput.vat_tax = 'Please enter VAT %';
            //     hasError = true;
            // }
            if (!rentalInvoiceView.management_bank_id) {
                validateNewInput.management_bank_id = 'Please select Management Fee Bank %';
                hasError = true;
            }
        }
        if (hasError) {
            this.setState({ error: validateNewInput });
            return;
        }
     
        data = {
            ...data,
            is_rental: true
        }
        this.props.updateRentalInvoice(payload);
    }
    render() {
        const { rentalInvoiceView, adminFlag, contracterFlag } = this.state;
        const { type, activeTab } = this.props;
        const startDate = moment(this.props.rentalInvoiceView?.contractual_start_date).date();
        if (![1, 29, 30, 31].includes(startDate) && !this.state.rentalInvoiceView.lease_based_invoice_start_day) {
            this.setState(prev => ({ rentalInvoiceView: { ...prev.rentalInvoiceView, lease_based_invoice_start_day: startDate } }))
        }
        return (
            <form onSubmit={(e) => this.updateRentalInvoice(e)}>
                <div style={{ height: (window.innerHeight - 180) + 'px', overflow: 'auto', marginBottom: '60px' }}>
                    {activeTab==='1'?
                    <Row>
                        <FieldCol md="12">
                            <FieldGroup className="form-group" >
                                <FieldLabel className="label">
                                    Auto Invoice Generation Day ( For Every Month )
                                </FieldLabel>
                                <FieldSelect
                                    placeholder='Select Day'
                                    keyParam="rental_invoice_day_of_month"
                                    value={rentalInvoiceView.rental_invoice_day_of_month}
                                    type={type}
                                    options={days}
                                    updateField={this.updateForm}
                                    labelKey='label'
                                    valueKey='value'
                                />
                            </FieldGroup>

                        </FieldCol>
                        <FieldCol md="12">
                            <FieldGroup className="form-group" >
                                <FieldLabel className="label">Invoice Due Day ( For Every Month )</FieldLabel>
                                <FieldSelect
                                    placeholder='Select Day'
                                    keyParam="rental_invoice_due_day_of_month"
                                    value={rentalInvoiceView.rental_invoice_due_day_of_month}
                                    disabled={rentalInvoiceView.rental_invoice_is_due_day_last_day_month===true}
                                    type={type}
                                    options={days}
                                    updateField={this.updateForm}
                                    labelKey='label'
                                    valueKey='value'
                                />
                            </FieldGroup>
                        </FieldCol>
                        <FieldCol md="12">
                            <FieldGroup className="form-group" >
                                <FieldLabel className="label">
                                    Default Bank
                                </FieldLabel>
                                <FieldSelect
                                    placeholder='Select Bank'
                                    keyParam="rental_default_bank"
                                    value={rentalInvoiceView.rental_default_bank}
                                    type={type}
                                    options={this.state.bankList}
                                    updateField={this.updateForm}
                                    labelKey='name'
                                    valueKey='id'
                                />
                            </FieldGroup>

                        </FieldCol>
                        <Col md="12">
                            <div className="form-group" >
                                <label className="label">
                                    <input type="checkbox" name="mr-invoice" checked={rentalInvoiceView.rental_invoice_is_due_day_next_month} onChange={(e) => this.updateForm('rental_invoice_is_due_day_next_month', e.target.checked)} />
                                    <span> Invoice Due Day falls in next Month</span>
                                </label>
                            </div>
                        </Col>
                        {jetStreamInstance?
                            <Col md="12">
                                <div className="form-group" >
                                    <label className="label">
                                        <input type="checkbox" name="mr-invoice" checked={rentalInvoiceView.rental_invoice_is_due_day_last_day_month} onChange={(e) => this.updateForm('rental_invoice_is_due_day_last_day_month', e.target.checked)} />
                                        <span>Invoice Due Day falls at last day of the Billing Month</span>
                                    </label>
                                </div>
                            </Col> :null
                        }
                            <FieldCol md='12'>
                                <FieldGroup className='form-group'>
                                    <FieldLabel className="label" style={{marginBottom:'10px'}}>Rental Billing Cycle </FieldLabel>
                                    <FieldLabel className="label" style={{ display: 'block' }}>
                                        <span ><input onClick={(e) => type !== 'view' ? this.updateForm('lease_rental_period', 1) : null} disabled={type === 'view' ? true : false} style={{ marginRight: '5px', cursor: 'pointer' }} checked={rentalInvoiceView.lease_rental_period === 1} type="radio" />Monthly</span>
                                        <span onClick={(e) => e.preventDefault()} style={{ marginLeft: '20px' }}><input onClick={(e) => { e.stopPropagation(); if (type !== 'view') { this.updateForm('lease_rental_period', 2); } }} disabled={type === 'view' ? true : false} style={{ marginRight: '5px', cursor: 'pointer' }} checked={rentalInvoiceView.lease_rental_period === 2} type="radio" />As Per Lease Period</span>
                                    </FieldLabel>
                                </FieldGroup>
                            </FieldCol>
                            {rentalInvoiceView.lease_rental_period === 2 ?
                                <FieldCol md="12">
                                    <FieldGroup className="form-group" >
                                        <FieldLabel className="label">
                                            Invoice Day<sup className="reqStar"> * </sup>
                                        </FieldLabel>
                                        <FieldSelect
                                            placeholder='Select Day'
                                            keyParam="lease_based_invoice_start_day"
                                            value={rentalInvoiceView.lease_based_invoice_start_day}
                                            type={type}
                                            options={days.filter(day => ![1, 29, 30].includes(day.value))}
                                            updateField={this.updateForm}
                                            labelKey='label'
                                            valueKey='value'
                                        />
                                        <h6 className="error-msg">{this.state.error?.lease_based_invoice_start_day}</h6>
                                    </FieldGroup>
                                </FieldCol> : null}
                        <FieldCol md="12">
                            <FieldGroup className="form-group" >
                                <FieldLabel className="label">Description</FieldLabel>
                                <FieldTextarea
                                    value={rentalInvoiceView.rental_description}
                                    type={type}
                                    keyParam="rental_description"
                                    updateField={this.updateForm}
                                />
                            </FieldGroup>
                        </FieldCol>
                            {hanwahaInstance ? <FieldCol md="12">
                                <FieldGroup className="form-group" >
                                    <FieldLabel className="label">Account Code</FieldLabel>
                                    <FieldTextarea
                                        value={rentalInvoiceView?.rental_account_code}
                                        type={type}
                                        keyParam="rental_account_code"
                                        updateField={this.updateForm}
                                        maxLength={5}
                                    />
                                </FieldGroup>
                            </FieldCol> : null}
                        {(titanInstance || gaTelesisInstance || avationPlcInstance || mtInstance || leshaBankInstance)  ? <FieldCol md="12">
                            <FieldGroup className="form-group" >
                                <FieldLabel className="label">Reference Number</FieldLabel>
                                <FieldTextarea
                                    value={rentalInvoiceView.reference_number_rental}
                                    type={type}
                                    keyParam="reference_number_rental"
                                    updateField={this.updateForm}
                                    maxLength={(titanInstance || avationPlcInstance || mtInstance || leshaBankInstance)? null : 250}
                                />
                            </FieldGroup>
                        </FieldCol> :null }
                        {(gaTelesisInstance) ? <>
                            <FieldCol md="12">
                                <FieldGroup className="form-group" >
                                    <FieldLabel className="label">QIS Number</FieldLabel>
                                    <FieldTextarea
                                        value={rentalInvoiceView?.rental_account_titan_extra_fields?.rental_qis_number}
                                        type={type}
                                        keyParam="rental_qis_number"
                                        updateField={this.updateForm}
                                        maxLength={250}
                                    />
                                </FieldGroup>
                            </FieldCol>
                            <FieldCol md="12">
                                <FieldGroup className="form-group" >
                                    <FieldLabel className="label">Sales Order Number</FieldLabel>
                                    <FieldTextarea
                                        value={rentalInvoiceView?.rental_account_titan_extra_fields?.rental_sales_order_number}
                                        type={type}
                                        keyParam="rental_sales_order_number"
                                        updateField={this.updateForm}
                                        maxLength={250}
                                    />
                                </FieldGroup>
                            </FieldCol></> : null}                      
                        {(titanInstance || avationPlcInstance || mtInstance || leshaBankInstance)?<>
                        <FieldCol md="12">
                                <FieldGroup className="form-group" >
                                    <FieldLabel className="label">Remarks</FieldLabel>
                                    <FieldTextarea
                                        value={rentalInvoiceView.remarks_rental}
                                        type={type}
                                        keyParam="remarks_rental"
                                        updateField={this.updateForm}
                                        maxLength={500}
                                    />
                                </FieldGroup>
                            </FieldCol> 
                            <FieldCol md="12">
                                <FieldGroup className="form-group" >
                                <FieldLabel className="label">Remarks Date</FieldLabel>
                               <FieldDate
                               value={rentalInvoiceView?.rental_account_titan_extra_fields?.remarks_date}
                               type={type}
                               keyParam="remarks_date"
                               updateField={this.updateForm}
                               disable={type == 'view' ? true : false}
                           />
                           </FieldGroup>
                           </FieldCol>
                           </>
                            : ""}
                     
                    </Row>
                        :
                        <Row>
                            <FieldCol md="12">
                                <FieldGroup className="form-group" >
                                    <FieldLabel className="label">Management Fee %<sup className="reqStar"> * </sup></FieldLabel>
                                    <FieldInput
                                        value={rentalInvoiceView.management_tax||''}
                                        type={type}
                                        keyParam="management_tax"
                                        accept='percentage'
                                        updateField={this.updateForm}
                                    />
                                    <h6 className="error-msg">{this.state.error.management_tax}</h6>
                                </FieldGroup>
                            </FieldCol>
                            <FieldCol md="12">
                                <FieldGroup className="form-group" >
                                    <FieldLabel className="label">VAT %</FieldLabel>
                                    <FieldInput
                                        value={rentalInvoiceView.vat_tax||''}
                                        type={type}
                                        accept='percentage'
                                        keyParam="vat_tax"
                                        updateField={this.updateForm}
                                    />
                                    {/* <h6 className="error-msg">{this.state.error.vat_tax}</h6> */}
                                </FieldGroup>
                            </FieldCol>
                            <FieldCol md="12">
                                <FieldGroup className="form-group" >
                                    <FieldLabel className="label"> Management Fee Bank<sup className="reqStar"> * </sup></FieldLabel>
                                    <FieldSelect
                                        placeholder='Select Bank'
                                        keyParam="management_bank_id"
                                        value={rentalInvoiceView.management_bank_id||null}
                                        type={type}
                                        options={this.state.bankList}
                                        updateField={this.updateForm}
                                        labelKey='name'
                                        valueKey='id'
                                    />
                                    <h6 className="error-msg">{this.state.error.management_bank_id}</h6>
                                </FieldGroup>
                            </FieldCol>
                        </Row>
                    }
                </div>
                <div className="submit-block">
                    <input type="submit" className="primary-btn" value="Save Changes" />
                    <Link onClick={() => { this.props.toggleEditSideBar(); this.setState({ error: {} }) }} >Cancel</Link>
                </div>
            </form>
        )
    }
}